import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.jsx';
import { useToast } from '../../context/ToastContext.jsx';
import './AdminLayout.css';

// perm: 需要的權限碼；沒有 perm 的（如儀表板）一律顯示
const NAV = [
  { to: '/admin',           label: '儀表板', icon: '◇', end: true, perm: 'dashboard' },
  { to: '/admin/products',  label: '商品管理', icon: '◫', perm: 'product' },
  { to: '/admin/themes',    label: '主題圖鑑', icon: '✦', perm: 'theme' },
  { to: '/admin/virtual',   label: '虛擬商品', icon: '✶', perm: 'virtual' },
  { to: '/admin/orders',    label: '訂單管理', icon: '⬚', perm: 'order' },
  { to: '/admin/inquiries', label: '登記管理', icon: '✎', perm: 'inquiry' },
  { to: '/admin/users',     label: '使用者管理', icon: '☷', perm: 'users' },
  { to: '/admin/membership-levels', label: '會員等級', icon: '♛', perm: 'membership' },
  { to: '/admin/roles',     label: '角色權限', icon: '◈', perm: 'roles' },
  { to: '/admin/settings',  label: '設定',    icon: '⚙', perm: 'catalog' },
];

function AdminLayout() {
  const { user, logout, hasPermission } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const navItems = NAV.filter(item => !item.perm || hasPermission(item.perm));

  const handleLogout = async () => {
    await logout();
    showToast('已登出', 'info', 2500);
    navigate('/');
  };

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <Link to="/admin" className="admin-brand">
          <div className="admin-brand-mark">道</div>
          <div>
            <b>MICHIDART</b>
            <small>ADMIN PANEL</small>
          </div>
        </Link>

        <nav className="admin-nav">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `admin-nav-item${isActive ? ' on' : ''}`}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-foot">
          <div className="admin-user">
            <div className="admin-user-avatar">{user?.initial}</div>
            <div>
              <b>{user?.name}</b>
              <small>{user?.email}</small>
            </div>
          </div>
          <Link to="/" className="admin-foot-link">← 回到前台</Link>
          <button className="admin-foot-link danger" onClick={handleLogout}>登出</button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
